export function timeformatt(_seconds, _local, _tz) {
  if (!_seconds) {
    return "";
  }
  if (!_local||! _tz) {
    return timetoUTC(_seconds).time;
  }
  return timeformatLoc(_seconds, _local,_tz);
}

export function dateformatt(_seconds, _local, _tz) {
  if (!_seconds) {
    return "";
  }
  if (!_local||! _tz) {
    return timetoUTC(_seconds).date;
  }
  return dateformatLoc(_seconds, _local,_tz);
}

export function dateTimeFormat(_seconds, _local, _tz) {
  if (!_seconds) {
    return "";
  }
  if (!_local||! _tz) {
    return timetoUTC(_seconds).dateTime;
  }
  return dateTimeFormatLoc(_seconds, _local,_tz);
}

export function dateTimeFormatLoc(dateSec, locale, tz) {
  if (!dateSec) {
    return null;
  }
  //TODO get current time zone
  locale = "en-US";
  return new Intl.DateTimeFormat(locale, {
    timeZone: tz,
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(dateSec * 1000);
}

export function timetoUTC(_seconds) {

  let date = epochSecondsToDate(_seconds);
  
  return {
    full: date,
    date: `${twoCipherCheck(date.day)} ${date.monthShortName} ${date.year}`,
    time: `${twoCipherCheck(date.hours)}:${twoCipherCheck(date.minutes)}:${twoCipherCheck(date.seconds)}`,
    dateTime: `${twoCipherCheck(date.day)} ${date.monthShortName} ${date.year} ${twoCipherCheck(date.hours)}:${twoCipherCheck(date.minutes)}:${twoCipherCheck(date.seconds)}`,
  };
}
function twoCipherCheck(num_val){
  return num_val<10?'0'+num_val:num_val
}
function epochSecondsToDate(epochSeconds) {
  const daysInMonth = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const daySeconds = 24 * 60 * 60;

  // Calculate years
  let years = 1970;
  while (
    epochSeconds >= (isLeapYear(years) ? 366 * daySeconds : 365 * daySeconds)
  ) {
    epochSeconds -= isLeapYear(years) ? 366 * daySeconds : 365 * daySeconds;
    years++;
  }

  // Calculate days
  let days = Math.floor(epochSeconds / daySeconds) + 1;
  epochSeconds %= daySeconds;

  // Calculate months and days
  let month, day;
  for (month = 1; month <= 12; month++) {
    const monthDays =
      isLeapYear(years) && month === 2 ? 29 : daysInMonth[month];
    if (days <= monthDays) {
      day = days;
      break;
    }
    days -= monthDays;
  }

  // Calculate hours, minutes, and seconds
  const hours = Math.floor(epochSeconds / 3600);
  epochSeconds %= 3600;
  const minutes = Math.floor(epochSeconds / 60);
  const seconds = epochSeconds % 60;

  // Format the date string
  const dateString = `${day}/${month}/${years} ${hours}:${minutes}:${seconds}`;
  return {
    dateString: dateString,
    year: years,
    month: month,
    monthLongName: getLocalizedMonthName(month),
    monthShortName: getLocalizedMonthName(month, null, "short"),
    day:day,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  };
}

function isLeapYear(year) {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}
function getLocalizedMonthName(monthNumber, locale, op) {
  if (!locale) {
    locale = "en-US";
  }
  const date = new Date(Date.UTC(2000, monthNumber - 1, 1)); // Create a date object with the desired month to retrive the name
  const monthName = date.toLocaleString(locale, { month: op ? op : "long" });
  return monthName;
}

export function dateformatLoc(dateSec, locale, tz) {
  if (!dateSec) {
    return null;
  }
  //TODO rm when add localization
  // locale = "en-US";
  return new Intl.DateTimeFormat(locale, {
    timeZone: tz,
    year: "numeric",
    month: "short",
    day: "2-digit",
  }).format(dateSec * 1000);
}
export function timeformatLoc(dateSec, locale, tz) {
  if (!dateSec) {
    return null;
  }
  //TODO rm when add localization
  // locale = "en-US";
  return new Intl.DateTimeFormat(locale, {
    timeZone: tz,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(dateSec * 1000);
}
//return amount of time given seconds formatted in d h m s
export function getTime(dateSec) {
  let seconds = Number(dateSec);
  var d = Math.floor(seconds / (3600 * 24));
  var h = Math.floor((seconds % (3600 * 24)) / 3600);
  var m = Math.floor((seconds % 3600) / 60);
  var s = Math.floor(seconds % 60);

  //   var dDisplay = d > 0 ? d + (d == 1 ? " day, " : " days, ") : "";
  //   var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
  //   var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
  //   var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
  var dDisplay = d > 0 ? d + "d " : "";
  var hDisplay = h > 0 ? h + "h " : "";
  var mDisplay = m > 0 ? m + "m " : "";
  var sDisplay = s > 0 ? s + "s" : "";
  return dDisplay + hDisplay + mDisplay + sDisplay;
}

export function secondsToFormattedString(seconds) {
  const date = new Date(0); // Start with the epoch
  date.setUTCSeconds(seconds);

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const secondsFormatted = String(date.getUTCSeconds()).padStart(2, '0');
  const millisecondsFormatted = String(date.getUTCMilliseconds()).padStart(3, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}:${secondsFormatted}.${millisecondsFormatted}`;
}

// Example usage
const seconds = 3600; // 1 hour
const formattedString = secondsToFormattedString(seconds);
console.log(formattedString);

export function formattedStringToSeconds(formattedString) {
  const parts = formattedString.match(/\d+/g).map(Number);
  const [year, month, day, hours, minutes, seconds, milliseconds = 0] = parts;
  const date = new Date(0);
  date.setUTCFullYear(year);
  date.setUTCMonth(month - 1);
  date.setUTCDate(day);
  date.setUTCHours(hours);
  date.setUTCMinutes(minutes);
  date.setUTCSeconds(seconds);
  date.setUTCMilliseconds(milliseconds);

  return date.getTime() / 1000;
}

// Example usage
const formattedStringInput = "1970-01-01T01:00:00.000";
const secondsOutput = formattedStringToSeconds(formattedStringInput);
console.log(secondsOutput);
